import React from 'react';
import PropTypes from 'prop-types'

const styles = {
  container: {
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    overflow: 'hidden',
  },
  queue: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: '50%',
    zIndex: 1,
    width: '500%',
    marginLeft: '-250%',
    animation: 'phAnimation 0.8s linear infinite',
    background: 'linear-gradient(to right, rgba(255, 255, 255, 0) 46%, rgba(255, 255, 255, 0.35) 50%, rgba(255, 255, 255, 0) 54%) 50% 50%',
  },
};

const PlaceholderLoader = ({ children }) => (
  <div style={styles.container}>
    <span style={styles.queue}> </span>
    { children }
  </div>
)

PlaceholderLoader.propTypes = {
  children: PropTypes.node,
}

export default PlaceholderLoader
